/**
 * Packaging OS — RiskPill (Phase 1P-B).
 *
 * Visualizes claim_risk.risk_level with the risk-severity color tokens.
 * The label is provided by the caller (already localized) so no English
 * leaks into ar/fa/tr renders.
 */

import type { DryRunClaimRisk } from "../api/client";

interface RiskPillProps {
  level: DryRunClaimRisk["risk_level"];
  label: string;
}

export function RiskPill({ level, label }: RiskPillProps): JSX.Element {
  return (
    <span
      className={`po-risk-pill po-risk-pill--${level}`}
      role="status"
      aria-label={label}
    >
      <span>{label}</span>
    </span>
  );
}
